import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { StatusLabelComponent } from '@principle-theorem/ng-principle-shared';
import {
  type AutomationStatus,
  AUTOMATION_STATUS_COLOUR_MAP,
} from '@principle-theorem/principle-core/interfaces';
import { Observable, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'pr-automation-status',
  templateUrl: './automation-status.component.html',
  styleUrls: ['./automation-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NgMaterialModule, StatusLabelComponent],
})
export class AutomationStatusComponent {
  status$ = new ReplaySubject<AutomationStatus>(1);
  colour$: Observable<string>;
  @Input() errorMessage?: string;

  @Input()
  set status(status: AutomationStatus) {
    if (status) {
      this.status$.next(status);
    }
  }

  constructor() {
    this.colour$ = this.status$.pipe(
      map((status) => AUTOMATION_STATUS_COLOUR_MAP[status])
    );
  }
}
